import script from "./ProfileStudentHorizontalFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileStudentHorizontalFilter.vue?vue&type=script&setup=true&lang=js"

import "./ProfileStudentHorizontalFilter.vue?vue&type=style&index=0&id=92786db4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92786db4"]])

export default __exports__